<template>
<div class="mod-config">
    <div style="border-radius: 30px">
        <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-row>
                <el-form-item label="状态" prop="applyStatus">
                        <el-select v-model="applyStatus" clearable placeholder="请选择" @change="getDataList">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                <el-form-item class="fr">
                    <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left: 20px">查询
                    </el-button>
                    <el-button icon="el-icon-plus" type="primary" @click="newinfor()">新建</el-button>
                    <el-button icon="el-icon-check" type="primary" @click="submitshenqing()">提交申请</el-button>
                </el-form-item>
            </el-row>
        </el-form>
    </div>

    <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName" :height="style.gridStyle.height" @selection-change="selectionChangeHandle" border :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column align="center" v-model="something" type="selection" width="55">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>

            <el-table-column prop="applyformNum" header-align="center" align="left" label="申请单号" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.applyformNum }}
                </template>
            </el-table-column>

            <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="enterpriseName" header-align="center" align="left" label="供应商名称" min-width="200">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleCheck(scope.row)">
                        {{ scope.row.enterpriseName }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="createTimeStr" header-align="center" align="left" label="申请日期" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.createTimeStr }}
                </template>
            </el-table-column>
            <el-table-column prop="applyStatus" header-align="center" align="left" label="状态" width="250">
                <template slot-scope="scope">
                    {{ scope.row.applyStatus }}
                </template>
            </el-table-column>

            <el-table-column prop="disReason" header-align="center" align="left" label="驳回原因" width="250">
                <template slot-scope="scope">
                    {{ scope.row.disReason }}
                </template>
            </el-table-column>
            <el-table-column align="center" header-align="center" label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.applyStatus === '新建' || scope.row.applyStatus === '提交供应商变更申请'" icon="el-icon-edit" type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.applyStatus === '新建'" icon="el-icon-delete" type="text" size="mini" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>

    <!--弹窗-->
    <el-dialog title="新建变更信息" :visible.sync="adddialogVisible" width="1200px" @close="closedialog">
        <el-form>
            <el-row>
                <el-form-item label="供应商管理员">
                    <!-- <el-select
              v-model="dataform.approvedBy"
              placeholder="请选择供应商管理员"
            >
              <el-option
                v-for="item in options2"
                :key="item.userId"
                :label="item.name"
                :value="item.userId"
              >
              </el-option>
            </el-select> -->
                    <el-button icon="el-icon-circle-check" type="primary" @click="handleSave()">保存</el-button>
                    <el-button icon="el-icon-plus" type="primary" @click="handleNewRows()">添加</el-button>
                </el-form-item>
            </el-row>
        </el-form>
        <el-table-editabled :model="dataList2" ref="editTable">
            <el-table border :data="dataList2" @row-click="editAll" :row-class-name="rowClassName" ref="table">
                <el-table-column label="序号" align="center" header-align="center" width="50">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="fieldName" label="项目" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-select @change="test($event, scope.row)" filterable value-key="item.value" :remote-method="remoteMethod" v-model="scope.row.fieldName" placeholder="请选择">
                            <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="venderOldInfo" label="原信息" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.fieldName == '企业性质'" style="width: 100%" v-model="scope.row.venderOldInfo" disabled>
                            <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.fieldName == '供应商关系'" style="width: 100%" v-model="scope.row.venderOldInfo" disabled>
                            <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>

                        <div class="input-box" v-else>
                            <el-input v-model="scope.row.venderOldInfo" disabled placeholder="原信息"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="venderNewInfo" label="新信息" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.fieldName == '企业性质'" style="width: 100%" v-model="scope.row.venderNewInfo" :disabled="
                  scope.row.applyStatus == '1' || scope.row.applyStatus == '3'
                ">
                            <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.fieldName == '供应商关系'" style="width: 100%" v-model="scope.row.venderNewInfo" :disabled="
                  scope.row.applyStatus == '1' || scope.row.applyStatus == '3'
                ">
                            <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                      <el-date-picker v-else-if="scope.row.fieldName === '营业执照到期日期'||scope.row.fieldName === '16949/9000体系证书到期日期'||scope.row.fieldName === '营业执照长期'" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" type="date" style="width: 100%" v-model="scope.row.venderNewInfo">
                      </el-date-picker>
                        <el-input v-else-if="scope.row.fieldName == '开户行行号'" v-model="scope.row.venderNewInfo" :disabled="
                  scope.row.applyStatus == '1' || scope.row.applyStatus == '3'
                " placeholder="开户行行号" @blur="blurSwiftCode(scope.row.venderNewInfo)"></el-input>

                        <el-input v-else v-model="scope.row.venderNewInfo" :disabled="
                  scope.row.applyStatus == '1' || scope.row.applyStatus == '3'
                " placeholder="新信息"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center" width="60" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="deleteRow(scope.$index,scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <hr />
            <div style="display: flex">
                <!-- <el-button type="primary" @click="beforeUploadForm1">上传</el-button>
                <el-upload class="upload-demo" :action="uploadURL" :show-file-list="false" :with-credentials="true" :data="ruleForm" :file-list="fileList" :on-success="successHandle" :before-upload="beforeUploadForm">
                </el-upload> -->
                <el-upload action :http-request="upload" :data="param" :show-file-list="false" style="text-align: right" multiple>
                    <el-button slot="trigger" class="mb15" type="primary">点击上传</el-button>
                </el-upload>
                <div style="margin-left: 30%">
                    <span style="color: red">*</span>
                    <span>注：修改部分信息需要上传附件进行作证，否则会被驳回</span>
                </div>
            </div>
            <el-table border :data="dataList3" style="margin-top: 20px">
                <el-table-column prop="originalName" header-align="center" align="left" label="文件名称">
                </el-table-column>

                <!-- <el-table-column
                prop="fileDesc"
                header-align="center"
                align="left"
                label="文件描述">
            </el-table-column> -->

                <el-table-column prop="fileSize" header-align="center" align="right" label="文件大小">
                </el-table-column>

                <el-table-column prop="fileDir" header-align="center" align="center" width="120" label="查看附件">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.fileType === 'application/pdf'" icon="el-icon-view" type="text" @click="viewHandle(scope.row)">查看</el-button>
                        <el-button v-else icon="el-icon-view" type="text" @click="viewHandle(scope.row)">下载</el-button>
                        <el-button type="text" @click="deleteFile(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-table-editabled>
    </el-dialog>

    <!--点击供应商名称查看-->
    <el-dialog title="查看变更信息" :visible.sync="checkdialogVisible" width="1200px">
        <el-table-editabled :model="dataList1">
            <el-table border :data="dataList1">
                <el-table-column label="序号" align="center" header-align="center" width="70">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="fieldName" label="项目" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.fieldName" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="venderOldInfo" label="原信息" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.fieldName == '企业性质'" style="width: 100%" v-model="scope.row.venderOldInfo" disabled>
                            <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="scope.row.fieldName == '供应商关系'" style="width: 100%" v-model="scope.row.venderOldInfo" disabled>
                            <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>

                        <el-input v-else v-model="scope.row.venderOldInfo" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="venderNewInfo" label="新信息" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.fieldName == '企业性质'" style="width: 100%" v-model="scope.row.venderNewInfo" disabled>
                            <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                      <el-date-picker v-else-if="scope.row.fieldName === '营业执照到期日期'||scope.row.fieldName === '16949/9000体系证书到期日期'||scope.row.fieldName === '营业执照长期'" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" type="date" style="width: 100%" v-model="scope.row.venderNewInfo" disabled>
                      </el-date-picker>
                        <el-select v-else-if="scope.row.fieldName == '供应商关系'" style="width: 100%" v-model="scope.row.venderNewInfo" disabled>
                            <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>

                        <el-input v-else v-model="scope.row.venderNewInfo" disabled></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <hr />
            <el-table border :data="dataList4">
                <el-table-column prop="originalName" header-align="center" align="left" label="文件名称">
                </el-table-column>

                <!-- <el-table-column
                prop="fileDesc"
                header-align="center"
                align="left"
                label="文件描述">
            </el-table-column> -->

                <el-table-column prop="fileSize" header-align="center" align="right" label="文件大小">
                </el-table-column>

                <el-table-column prop="fileDir" header-align="center" align="center" width="120" label="查看附件">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.fileType === 'application/pdf'" icon="el-icon-view" type="text" @click="viewHandle(scope.row)">查看</el-button>
                        <el-button v-else icon="el-icon-view" type="text" @click="viewHandle(scope.row)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-table-editabled>
    </el-dialog>
<pdf-view v-if="pdfPreviewVisible" ref="pdfPreview"></pdf-view>
</div>
</template>

<script>
import {
    findTablenamelist,
    findValueByTable,
    saveChange,
    selectChangeInfoApplyPage,
    selectChangeInfoList,deleteChange,executeApply,deleteSupplierChangeInfo
} from '@/controller/portal'
import {
    getBankCount,getProvinceList
} from '@/controller/systemData'
import { listAllStatus} from '@/controller/workflow'
import {
    getFileList,
    uploadFile,
    getUrl,
    deleteFileById
} from '@/controller/sys'
import { uuid } from 'vue-uuid'
import PdfView from '@/components/pdf-view'
import {
    FILE_BIZ_TYPE,
    getLabelByValue
} from '@/utils/const'

export default {
    data() {
        return {
            pdfPreviewVisible: false,
            FILE_BIZ_TYPE:4,
            FILE_SUB_TYPE:9,
            tableData: [],
            applyStatus: '',
            uploadURL: "",
            something: "",
            something2: "",
            adddialogVisible: false,
            checkdialogVisible: false,
            dataListLoading: false,
            dataForm: {
                key: "",
            },
            ruleForm: {
                venderId: '',
                sysFileDescribe: '',
                applyformId: 0
            },
            list: [],
            dataList: [],
            dataList1: [],
            dataList2: [],
            dataList3: [],
            dataList4: [],
            fileList: [],
            getNameList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListSelections: [],
            dataListSelections2: [],
            style: {
                leftStyle: {
                    height: parseInt(document.documentElement["clientHeight"]) - 325 + "px",
                    overflow: "auto",
                },
                rightStyle: {
                    height: parseInt(document.documentElement["clientHeight"]) - 205 + "px",
                },
                gridStyle: {
                    height: parseInt(document.documentElement["clientHeight"]) - 215 + "px",
                },
            },
            // 企业性质
            options3: [{
                    label: '私有控股',
                    value: '0'
                },
                {
                    label: '国有（集体）控股',
                    value: '1'
                },
                {
                    label: '中外合资企业',
                    value: '2'
                },
                {
                    label: '外商独资企业',
                    value: '3'
                }
            ],
            options4: [{
                    label: '公司所属供应商',
                    value: '0'
                },
                {
                    label: '股东供应商',
                    value: '1'
                },
                {
                    label: '一般供应商',
                    value: '2'
                }
            ],
            provinceOptions: [],
            options1:[],
            param: {
                bizId: '',
                bizType: '',
                fileSubType: '',
            },
            fileId:'',
            applyFormFid:null,
            // 文件操作状态 1新建 2编辑 3查看
            fileOperationState: null,
        };
    },

    components: {PdfView},

    computed: {
        editTable() {
            return this.$refs.editTable
        }
    },

    activated() {
        this.fileId = uuid.v1();
        this.getDataList();
        this.findTablenamelist();
        this.getAllStatus();
    },

    methods: {
        // 查询按钮
        queryHandle() {
            this.pageIndex = 1;
            this.getDataList();
        },

        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },

        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },

        //多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },

        //单选
        radioChange(row) {
            this.dataListSelections = row;
        },

        rowClassName({
            row,
            rowIndex
        }) {
            //把每一行的索引放进row.id
            row.rowid = rowIndex + 1 + this.pageSize * (this.pageIndex - 1);
        },
        //多选
        selectionChangeHandle2(val) {
            this.dataListSelections2 = val;
        },
        deleteRow(index,row) {
            if(row.id) {
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteSupplierChangeInfo({
                        'id': row.id
                    }).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                   this.dataList2.splice(index,1)
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                });
            } else {
                this.dataList2.splice(index,1)
            }
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            selectChangeInfoApplyPage({
                'pageNo': this.pageIndex,
                'pageSize': this.pageSize,
                'applyStatus':this.applyStatus,
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
            //this.dataList = [];
        },

        closedialog() {
            this.adddialogVisible = false;
            this.venderOldInfo = "";
        },

        editAll() {
            // debugger
            if (this.applyStatus == 0 || this.applyStatus == 2) {
                this.dataList.map((i, index) => {
                    i.show = true;
                    Vue.set(this.dataList, index, i);
                });
            } else {
                this.show = false;
            }
        },

        beforeUploadForm1() {
            this.checkdialog = true;
        },

        // 上传成功
        successHandle(response, file, fileList) {
            debugger
            this.fileList = fileList
            this.successNum++
            if (response && response.code === 0) {
                this.$message({
                    message: '上传成功！！',
                    type: 'success'
                })
                this.checkdialog = false
                this.ruleForm.sysFileType = ''
                this.getDataList()
                //debugger
            } else {
                this.$message.error(response.msg)
            }
        },

        beforeUploadForm(file) {
            debugger
            if (this.ruleForm.sysFileDescribe == '') {
                alert("请先选择文件描述")
                this.checkdialog = false
                return false
            }
            this.checkdialog = false
        },

        newinfor() {
            this.fileOperationState = 1
            this.selectFileList(this.fileId)
            this.approvedBy = ''
            this.dataList2 = []
            this.dataList3 = []
            this.ruleForm.sysFileDescribe = ''
            this.applyformId = 0
            this.ruleForm.applyformId = 0
            this.adddialogVisible = true
        },

        handleNewRows() {
            this.dataList2.push({
                fieldName: '',
                venderNewInfo: '',
                venderOldInfo: '',
                edit: true,
            })
        },

        remoteMethod(query) {
            //debugger
            if (query == '' || query == 'undefined') {
                this.loading = true;
                setTimeout(() => {
                    // this.loading = false;
                    this.options = this.list.filter(item => {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },

        test(event, row) {
            console.log(event, 'event')
            console.log(row, 'row')
            if (event == "企业性质") {
                row.flag = 2
            } else if (event == "供应商关系") {
                row.flag = 3
            } else {
                row.flag = 1
            }
            //debugger
            this.getNameList.forEach((item) => {
                if (item.fieldName == event) {
                    row.fieldName = item.fieldName
                    row.field = item.field
                    this.$nextTick(() => {
                        this.getduiyinginfor(row)
                    })
                }
            })
        },

        getduiyinginfor(row) {
            findValueByTable({
                'field': row.field
            }).then(data => {
                if (data && data.code === '00') {
                    console.log(data, '字段值')
                    row.venderOldInfo = data.body
                }
            })
        },

        // 查询供应商基本信息表字段
        findTablenamelist() {
            findTablenamelist({}).then(data => {
                if (data && data.code === '00') {
                    this.getNameList = data.body

                    this.list = data.body.map(item => {
                        return {
                            ziduan: item.field, //描述对应的字段
                            value: item.fieldName, //描述
                            label: item.fieldName //描述
                        }
                    })
                }
            })
        },

        // 保存前的相关校验
        handleSave() {
            // 零行校验
            let iLength = this.dataList2.length;
            if (iLength == 0) {
                this.$message.error("请添加项目")
                return
            }
            if (this.dataList3.length == 0) {
                this.$message.error("请上传附件")
                return
            }

            // 非空校验 & 判断重复
            let tempSet = new Set();
            let swiftCode = "";
            let oneLength = false;
            let oneLengthFile = false;
            for (var i = 0; i < iLength; i++) {
                if (this.dataList2[i].fieldName == "" || this.dataList2[i].venderNewInfo == "") {
                    this.$message.error("请选择项目、并填写该项目的新信息")
                    return
                }
                // 准备判断重复列
                tempSet.add(this.dataList2[i].fieldName);
                // 准备检验开户行行号
                if (this.dataList2[i].fieldName == "开户行行号") {
                    swiftCode = this.dataList2[i].venderNewInfo;
                }

                //校验供应商的营业执照到期日期、16949/9000体系证书到期日期
                if((this.dataList2[i].fieldName === "营业执照到期日期" || this.dataList2[i].fieldName === "16949/9000体系证书到期日期")&&iLength !== 1){
                   oneLength=true
                }
                //校验供应商的营业执照到期日期、16949/9000体系证书到期日期 fujian
                if((this.dataList2[i].fieldName === "营业执照到期日期" || this.dataList2[i].fieldName === "16949/9000体系证书到期日期")&&this.dataList3.length !== 1){
                  oneLengthFile=true
                }
            }
            if(oneLength){
              this.$message.warning('营业执照（或16949/9000体系证书）到期日期变更需求单独提交，请只保留营业执照（或16949/9000体系证书）到期日期一行')
              return;
            }
            if(oneLengthFile){
              this.$message.warning('营业执照（或体系证书到）到期日期变更需求单独提交，请只保留一个附件')
              return;
            }
            // 判断重复列
            if(iLength != tempSet.size){
                this.$message.error("存在重复的项目")
                return
            }
            if(swiftCode !== ''){
                // 开户行行号校验
                getBankCount(
                    {'bankCode': swiftCode}
                ).then((data) => {
                    if (data && data.code === '00') {
                        if (data.body <= 0) {
                            this.$message.error("开户行行号不合法");
                            return;
                        } else {
                            // 保存变更信息
                            const me = this
                            this.saveData(me.dataList2)
                        }
                    } else {
                        this.$message.error(data.msg)
                        return;
                    }
                }).catch(function () {
                    this.$message.error("开户行行号校验，发送异常");
                    return;
                });
            }else{
                // 保存变更信息
                const me = this
                this.saveData(me.dataList2)
            }
        },

        // 保存变更信息
        saveData(list) {
            saveChange(
                {
                    'list':list,
                    'fileId': this.fileId
                }
                ).then(data => {
                    if (data && data.code === '00') {
                        // 保存成功后要获取新的UUID
                        this.fileId = uuid.v1();
                        this.adddialogVisible = false
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
            }).catch(() => {})
        },

        // 省
        getProvinceList() {
            getProvinceList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.provinceOptions = data.body;
                }
            });
        },

        //点击供应商名称查看信息
        handleCheck(row) {

            // this.applyformNum = row.id
            // this.applyformId = row.targetId

            this.$nextTick(() => {
                this.checkinfor(row.id, row.targetId)
            })
        },

        //点击供应商名称查看信息-查询
        checkinfor(id, targetId) {
            this.fileOperationState = 3
            this.checkdialogVisible = true
            this.selectFileList(id)
            selectChangeInfoList({
                'applyFormFid': id,
                'supplierBusinessId': targetId,
                'edit':'0'
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList1 = data.body
                }else{

                }
            }).catch(() => {})
        },

        // 编辑
        handleEdit(row) {
            this.fileOperationState = 2
            this.applyFormFid = row.id
            this.selectFileList(row.id)
            this.$nextTick(() => {
                selectChangeInfoList({
                'applyFormFid': row.id,
                'supplierBusinessId': row.targetId,
                'edit':'1'
            }).then(data => {
                if (data && data.code === '00') {
                    this.adddialogVisible = true
                    console.log(data, 'data')
                    this.dataList2 = data.body
                }else{
                    this.$message.error(data.msg)
                }
            }).catch(() => {})

            })
        },

        // 删除变更
        handleDelete(row){
            console.log(row,'啊')
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.dataListLoading = true
                deleteChange(
                    {
                        supplierBasicId : row.targetId,
                        applyFormFid : row.id
                    }
                    ).then(data => {
                    if(data && data.code === '00'){
                        this.dataListLoading = false
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    }else{
                        this.dataListLoading = false
                        this.$message.error(data.msg)
                    }
                }).catch(()=>{
                    this.dataListLoading = false
                }).finally(()=>{
                    this.dataListLoading = false
                })

            })
        },

        // 提交申请
        submitshenqing(){
            var array = [];
            this.dataListSelections.map(item => {
                array.push(
                    {
                        'supplierBasicId' : item.targetId,
                        'applyFormFid' : item.id,
                        'workflowId' : item.workFlowId,
                        'supplierId' : item.supplierId,
                        'applyStatus' : item.applyStatus,
                        'taskActions' : item.taskActions,
                    }
                    );
            })

            console.log(array,'array')

            if(array.length <= 0){
                this.$message.error("请选择要提交的数据")
                return
            }

            executeApply(array).then(data => {
                if(data && data.code === '00'){
                    this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1000,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                }else{
                    this.$message.error(data.msg)
                }
            }).catch(()=>{}).finally(()=>{})
        },

        // 查询状态列表
        getAllStatus(){
            listAllStatus({
                'processDefKey': 'SCI0'
            }).then(data => {
                if (data && data.code === '00') {
                    this.options1 = data.body.map(str => {
                        return {'value': str, 'label': str}
                    })
                }
            })
        },

        upload(obj) {
            var id = '';
            // 新建
            if(this.fileOperationState === 1){
                id = this.fileId
            }
            // 编辑
            if(this.fileOperationState === 2){
                id = this.applyFormFid
            }

            let formData = new FormData()
            formData.set('file', obj.file)
            formData.set('fileName', '文件名称')
            formData.set('id', id)
            formData.set('bizType', this.FILE_BIZ_TYPE)
            formData.set('fileSubType', this.FILE_SUB_TYPE)
            let fileDir = getLabelByValue(FILE_BIZ_TYPE, this.FILE_BIZ_TYPE);
            if (fileDir) {
                formData.set('fileDir', fileDir)
            } else {
                this.$message.error("请先配置附件的业务类型！");
                return;
            }

            // 先储存
            uploadFile(formData).then(data => {
                if (data.code === '00') {
                    this.selectFileList(id);
                    this.$message.success({
                        message: '上传成功！',
                        type: 'success',
                        duration: 1500,
                    });
                }else {
                  this.selectFileList(id);
                  this.$message.warning({
                    message:data.msg,
                    type:'warning',
                    duration:1500
                  })
                }
            })
        },

        // 查询文件列表
        selectFileList(id) {
            getFileList({
                'id': id,
                'bizType': this.FILE_BIZ_TYPE
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList3 = data.body
                    this.dataList4 = data.body
                } else {
                    this.dataList3 = []
                    this.dataList4 = []
                }
            })
        },

        viewHandle(row) {
            console.log(row, 'row')

            getUrl({
                'fileId': row.id
            }).then(data => {
                if (data && data.code === '00' && data.body) {
                    // location.href=data.body;
                    if (row.fileType === 'application/pdf') {
                        this.previewPdf(data.body)
                    } else {
                        this.download(data.body, row.originalName)
                    }
                } else {
                    this.tableData = []
                }
            })
        },

        previewPdf(pdfUrl) {
            this.pdfPreviewVisible = true
            this.$nextTick(() => {
                //此处参数传入pdf文件的地址
                this.$refs.pdfPreview.init(pdfUrl)
            })
        },

        download(url, filename) {
            const _this = this
            this.getBlob(url, function (blob) {
                _this.saveAs(blob, filename);
            });
        },

        getBlob(url, cb) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response);
                }
            };
            xhr.send();
        },

        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                var body = document.querySelector("body");

                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                // fix Firefox
                link.style.display = "none";
                body.appendChild(link);

                link.click();
                body.removeChild(link);

                window.URL.revokeObjectURL(link.href);
            }
        },

        deleteFile(row) {
          var id = '';
          // 新建
          if(this.fileOperationState === 1){
            id = this.fileId
          }
          // 编辑
          if(this.fileOperationState === 2){
            id = this.applyFormFid
          }
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                deleteFileById({
                    'fileId': row.id
                }).then(data => {
                    if (data.code === '00') {
                        this.selectFileList(id);
                        this.$message.success({
                            message: '删除成功！',
                            type: 'success',
                            duration: 1500,
                        });
                    }
                }).catch(() => {

                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
                this.viewData.visible = false;
            });

        },

        // 开户行行号——焦点离开事件
        blurSwiftCode: function (swiftCode) {
            if (null != swiftCode) {
                const loading = this.$loading({
                    lock: true,
                    text: "开户行行号校验中,请稍候",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                getBankCount(
                    {
                        'bankCode': swiftCode
                    }
                ).then((data) => {
                    if (data && data.code === '00') {
                        if (data.body <= 0) {
                            this.$message.error("开户行行号不合法");
                            loading.close();
                            return false;
                        } else {
                            loading.close();
                            return false;
                        }
                    } else {
                        this.$message.error(data.msg)
                        loading.close();
                        return false;
                    }
                }).catch(function () {
                    loading.close();
                    return false;
                });
            }
        },

    },
};
</script>

<style lang="scss">
.button-danger {
    color: #f56c6c;
}

.fr {
    float: right;
}
</style>
